import { connect } from 'react-redux';
import { pricingFormationDetailsSelector } from '../../../redux/product/product.selectors';
import { PricingFormationDetailsPopupComponent } from './pricing-formation-details-popup';
export const PricingFormationDetailsPopup = connect(pricingFormationDetailsSelector)(PricingFormationDetailsPopupComponent);